import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import './Contact.css';

const Contact = () => {
  return (
    <div className="contact-page">
      <section className="page-hero">
        <div className="hero-container">
          <h1 className="page-title">Contact Us</h1>
          <p className="page-subtitle">We're Here to Help</p>
        </div>
      </section>

      <section className="page-content">
        <div className="content-container">
          <div className="contact-intro">
            <h2 className="intro-title">Get in Touch</h2>
            <p className="intro-text">
              Have questions about our recovery housing programs? We're here to help. Contact us by phone or email, or visit one of our locations.
            </p>
          </div>

          <div className="contact-grid">
            {/* Women's Recovery — featured first */}
            <div className="contact-card">
              <div className="card-header">
                <h3 className="card-title">Women's Recovery House</h3>
                <p className="card-location">Catasauqua, Pennsylvania</p>
              </div>
              <div className="card-content">
                <div className="contact-item">
                  <MapPin size={24} className="contact-icon" />
                  <div className="contact-details">
                    <p className="detail-label">Location</p>
                    <p className="detail-value">Catasauqua, PA</p>
                  </div>
                </div>

                <div className="contact-item">
                  <Phone size={24} className="contact-icon" />
                  <div className="contact-details">
                    <p className="detail-label">Phone</p>
                    <a href="tel:610-443-0175" className="detail-link">
                      610-443-0175
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Men's Recovery */}
            <div className="contact-card">
              <div className="card-header">
                <h3 className="card-title">Men's Recovery House</h3>
                <p className="card-location">Whitehall, Pennsylvania</p>
              </div>
              <div className="card-content">
                <div className="contact-item">
                  <MapPin size={24} className="contact-icon" />
                  <div className="contact-details">
                    <p className="detail-label">Location</p>
                    <p className="detail-value">Whitehall, PA</p>
                  </div>
                </div>

                <div className="contact-item">
                  <Phone size={24} className="contact-icon" />
                  <div className="contact-details">
                    <p className="detail-label">Phone</p>
                    <a href="tel:570-579-7695" className="detail-link">
                      570-579-7695
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* General Contact Information */}
          <div className="general-contact">
            <h2 className="section-heading">General Inquiries</h2>
            <div className="general-contact-grid">
              <div className="general-contact-item">
                <div className="item-icon-wrapper">
                  <Phone size={32} className="item-icon" />
                </div>
                <h3 className="item-title">Phone</h3>
                <a href="tel:610-443-0175" className="item-value">
                  610-443-0175
                </a>
                <p className="item-description">Main contact line for all inquiries</p>
              </div>

              <div className="general-contact-item">
                <div className="item-icon-wrapper">
                  <Mail size={32} className="item-icon" />
                </div>
                <h3 className="item-title">Email</h3>
                <a href="mailto:Admin@prosolveglobalsolutions.com" className="item-value">
                  Admin@prosolveglobalsolutions.com
                </a>
                <p className="item-description">Send us your questions or concerns</p>
              </div>

              <div className="general-contact-item">
                <div className="item-icon-wrapper">
                  <Clock size={32} className="item-icon" />
                </div>
                <h3 className="item-title">Availability</h3>
                <p className="item-value">24/7 Support</p>
                <p className="item-description">We're here when you need us</p>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="contact-cta">
            <h2 className="cta-title">Ready to Begin Your Recovery Journey?</h2>
            <p className="cta-text">
              Our team is ready to answer your questions and help you take the next step toward recovery. Contact us today to learn more about our recovery housing programs.
            </p>
            <div className="cta-buttons">
              <a href="tel:610-443-0175" className="btn btn-primary">
                <Phone size={20} />
                Call Now
              </a>
              <a href="mailto:Admin@prosolveglobalsolutions.com" className="btn btn-secondary">
                <Mail size={20} />
                Send Email
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
